import { createSelector } from 'reselect'
import { RootState } from 'redux/store'
import { getAolOptionsByRole } from 'helpers/aol/aolHelpers'

const selectHasAol = createSelector(
  (state: RootState) => state.user.accessRoles,
  (accessRoles: string[]) => getAolOptionsByRole(accessRoles).some(opt => !opt.disabled)
)

export default selectHasAol
